import { GraphQLClient } from 'graphql-request';

import SimpleStore from '../../store/SimpleStore';
import { DynamicObject } from '../../utils/commonTypes';
import { GRAPHQL_ENDPOINT } from '../../utils/constants/ApiConstants';
import {
  HTTP_HEADER_KEYS,
  HTTP_URL_PARAMS
} from '../../utils/constants/HttpMethodsConstants';
import { createPersistedQueryFetch } from './CreatePersistedQuery';

export const getGraphQlClient = (
  requestObj: any,
  queryCode: string,
  query: string,
  headers?: string[]
): GraphQLClient => {
  //TODO: we are passing headers from every point we call the APIs, find:
  //1. cases where getCookie(XACCESS_AUTHORIZATION_COOKIE) returns null || 0
  //2. cases where we are not passing headers and hence depending on this default one. E.g. Search?
  // TODO: Remove hardcoded x-access-token
  const header: DynamicObject = {};
  if (headers) {
    headers.forEach((item) => {
      header[item] = SimpleStore.get(item);
    });
  } else {
    [
      HTTP_HEADER_KEYS.X_ACCESS_TOKEN,
      HTTP_HEADER_KEYS.X_Z5_GUEST_TOKEN
    ].forEach((item) => {
      header[item] = SimpleStore.get(item);
    });
  }
  if (header?.[HTTP_HEADER_KEYS.AUTHORIZATION]) {
    header[HTTP_HEADER_KEYS.AUTHORIZATION] = `bearer ${
      header[HTTP_HEADER_KEYS.AUTHORIZATION]
    }`;
  }
  const requiredParamKeys = [
    'id',
    'matchId',
    'episodeId',
    'seasonId',
    'showId'
  ];
  const platformName = 'web_app';
  const country = SimpleStore.get(HTTP_URL_PARAMS.COUNTRY_CODE) || '';
  const urlList = [GRAPHQL_ENDPOINT, platformName, country, queryCode];
  Object.keys(requestObj).forEach((key) => {
    if (requiredParamKeys.includes(key)) {
      urlList.push(requestObj[key]);
    }
  });

  const queryParams = {
    operationName: queryCode,
    variables: JSON.stringify(requestObj)
  };
  let url = urlList.reduce((previousValue, currentValue) =>
    currentValue ? `${previousValue}/${currentValue}` : previousValue
  );

  const queryString = Object.entries(queryParams)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`
    )
    .join('&');

  const newURl = `${url}?${queryString}&query=${query}`;

  if (query.includes('mutation')) {
    url = url.replace('apq', 'route');
    return new GraphQLClient(url, {
      headers: header
    });
  }

  return new GraphQLClient(newURl, {
    headers: header,
    fetch: createPersistedQueryFetch(fetch, queryCode)
  });
};
